/**
 * @file RowsPerPageSelectComponent.tsx
 * @description
 * -----------------------------------------------------
 * Componente de selector de número de filas
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-03-24
 * @modified 2025-05-27
 * @author DLTCode
 * @author Cristina Bosa
 * @author Nacho Moya
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useTranslations } from "next-intl";
import SelectComponent from "@/components/ui/SelectComponent";
import { DEFAULT_SIZE } from "@/constants/filters";
import { SelectRowsProps } from "@/types/pagination";
const RowsPerPageSelectComponent = t0 => {
  const $ = _c(40);
  const {
    table,
    page,
    pageSize,
    rowCount
  } = t0;
  const t = useTranslations("TableComponent.Pagination");
  const labels = useTranslations("Labels");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [5, 10, 20];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== rowCount) {
    t2 = t1.filter((_, index, array) => rowCount > (index > 0 ? array[index - 1] : 0));
    $[1] = rowCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const availableOptions = t2;
  const isSelectDisabled = availableOptions.length === 1;
  const fallbackRowsNumber = availableOptions[0] ?? DEFAULT_SIZE;
  const normalizedPageSize = isSelectDisabled ? 5 : availableOptions.includes(pageSize) ? pageSize : fallbackRowsNumber;
  let t3;
  let t4;
  if ($[3] !== availableOptions || $[4] !== fallbackRowsNumber || $[5] !== pageSize || $[6] !== table) {
    t3 = () => {
      if (availableOptions.length === 0) {
        return;
      }
      if (availableOptions.includes(pageSize)) {
        return;
      }
      table?.setPageSize?.(fallbackRowsNumber);
    };
    t4 = [availableOptions, fallbackRowsNumber, pageSize, table];
    $[3] = availableOptions;
    $[4] = fallbackRowsNumber;
    $[5] = pageSize;
    $[6] = table;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== table) {
    t5 = e => {
      const selectedValue = Number(e.target.value);
      if (table?.setPageSize) {
        table.setPageSize(selectedValue);
      }
    };
    $[9] = table;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleChange = t5;
  if (!table || rowCount <= 0) {
    return null;
  }
  const t6 = "rows-per-page-" + page;
  let t7;
  if ($[11] !== page) {
    t7 = <span className="sr-only">{page}</span>;
    $[11] = page;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== labels) {
    t8 = labels("labelRowsPerPage");
    $[13] = labels;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = <label htmlFor={t6} className="table__label">{t7}{t8}</label>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = "rows-per-page-" + page;
  let t11;
  if ($[19] !== normalizedPageSize) {
    t11 = normalizedPageSize.toString();
    $[19] = normalizedPageSize;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== availableOptions) {
    t12 = availableOptions.map(_temp);
    $[21] = availableOptions;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = "rows-per-page-" + page;
  let t14;
  if ($[23] !== handleChange || $[24] !== isSelectDisabled || $[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t13) {
    t14 = <SelectComponent id={t10} value={t11} options={t12} onChange={handleChange} name={t13} className="table__rows-select" disableAutoAriaLabelFallback={true} disabled={isSelectDisabled} />;
    $[23] = handleChange;
    $[24] = isSelectDisabled;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== rowCount || $[31] !== t) {
    t15 = t("results", {
      count: rowCount
    });
    $[30] = rowCount;
    $[31] = t;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== rowCount || $[34] !== t15) {
    t16 = <span className="table__label">/ {rowCount} {t15}</span>;
    $[33] = rowCount;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t14 || $[37] !== t16 || $[38] !== t9) {
    t17 = <section className="table__rows">{t9}{t14}{t16}</section>;
    $[36] = t14;
    $[37] = t16;
    $[38] = t9;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
};
export default RowsPerPageSelectComponent;
function _temp(num) {
  return {
    value: num,
    label: num.toString(),
    className: "table__rows-select-option"
  };
}